var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"my-4 mx-n2 px-2",attrs:{"color":"blue","text":"","rounded":""},on:{"click":_vm.handleBack}},[_c('v-icon',{staticClass:"me-2",attrs:{"size":"16"}},[_vm._v("mdi-arrow-left")]),_vm._v("\n  "+_vm._s(_vm.backText)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }